// extracted by mini-css-extract-plugin
export default {"link":"Link_link__DLONq","link_button":"Link_link_button__4g6pB","link_buttonTransparent":"Link_link_buttonTransparent__0TzXN","link_default":"Link_link_default__2x9q2"};